import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PRODUCT_LISTING_PAGE_ROUTE } from "../routes";
import getGoldmineAndUserId from "./Helpers/getGoldmineAndUserId";
import getQuickQuoteInitialValues from "./Helpers/getQuickQuoteInitialValues";
import getQuickQuoteValidationSchema from "./Helpers/getQuickQuoteValidationSchema";
import onSubmitForm from "./Helpers/onSubmitForm";

function useQuickQuote() {
  const [goldmineAndUserId, setGoldmineAndUserId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getGoldmineAndUserId(location.search).then((response) => {
      setGoldmineAndUserId(response);
    });
  }, [location.search]);

  const initialValues = getQuickQuoteInitialValues();

  const validationSchema = getQuickQuoteValidationSchema();

  const onSubmit = async (values, { setSubmitting }) => {
    const response = await onSubmitForm(values, goldmineAndUserId);
    console.log("response", response);

    // stop loading
    setSubmitting(false);

    if (response === null) return;

    // Navigating to plp page with product list
    navigate(`${PRODUCT_LISTING_PAGE_ROUTE}/`, {
      state: {
        response,
      },
    });
  };

  return {
    initialValues,
    validationSchema,
    onSubmit,
    initialLoading: !goldmineAndUserId,
  };
}

export default useQuickQuote;
